import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "antd";
import { AppstoreOutlined, ProjectOutlined, UserOutlined } from "@ant-design/icons";
import { RiBuilding2Fill, RiGraduationCapLine } from "react-icons/ri";
import { useTranslation } from "react-i18next";

/**
 * Sub-admin navigation. Meant to render inside the shell's desktop Sider and the phone nav
 * Drawer (commons/PanelsHeader), like the service-provider and super-admin sidebars.
 */
const SubAdminSidebar = () => {
  const { t } = useTranslation("dashboard");
  const { pathname } = useLocation();

  const items = [
    {
      type: "group",
      key: "main",
      label: t("Main"),
      children: [
        {
          key: "/subadmin",
          icon: <AppstoreOutlined />,
          label: <Link to="/subadmin">{t("Dashboard")}</Link>
        },
        {
          key: "/subadmin/departments",
          icon: <RiBuilding2Fill />,
          label: <Link to="/subadmin/departments">{t("Departments")}</Link>
        },
        {
          key: "/subadmin/designations",
          icon: <RiGraduationCapLine />,
          label: <Link to="/subadmin/designations">{t("Designations")}</Link>
        },
        {
          key: "/subadmin/projects",
          icon: <ProjectOutlined />,
          label: <Link to="/subadmin/projects">{t("Projects")}</Link>
        },
        {
          key: "/subadmin/profile",
          icon: <UserOutlined />,
          label: <Link to="/subadmin/profile">{t("Profile")}</Link>
        }
      ]
    }
  ];

  const selected =
    pathname === "/subadmin"
      ? "/subadmin"
      : items[0].children.find(i => i.key !== "/subadmin" && pathname.startsWith(i.key))?.key;

  return (
    <Menu
      className="sidersidenav"
      mode="inline"
      theme="light"
      selectedKeys={selected ? [selected] : []}
      items={items}
      style={{ height: "100%" }}
    />
  );
};

export default SubAdminSidebar;
